import { ArrowRight } from "lucide-react";

const Hero = () => (
  <section className="relative overflow-hidden pb-24 pt-40">
    <div className="bg-grid absolute inset-0" aria-hidden="true" />
    <div className="relative mx-auto max-w-6xl px-6">
      <p className="font-mono text-xs uppercase tracking-widest text-muted">
        Product &amp; software engineering studio — Sydney, AU
      </p>
      <h1 className="mt-6 max-w-3xl text-4xl font-semibold tracking-tight md:text-6xl">
        We build our own <span className="text-accent">products</span>.<br />
        We&rsquo;ll build yours too.
      </h1>
      <p className="mt-6 max-w-xl text-lg text-muted">
        We&rsquo;re a boutique studio that takes products from idea to
        production &mdash; our own, and a select few for clients.
      </p>
      <div className="mt-10 flex flex-wrap items-center gap-6">
        <a
          href="#products"
          className="inline-flex items-center gap-2 rounded-md bg-accent px-5 py-3 text-sm font-medium text-base transition-opacity hover:opacity-90"
        >
          See our products
          <ArrowRight className="h-4 w-4" />
        </a>
        <a
          href="mailto:hello@techlyft.com"
          className="font-mono text-sm text-muted underline decoration-line underline-offset-4 transition-colors hover:text-fg hover:decoration-accent"
        >
          hello@techlyft.com
        </a>
      </div>
    </div>
  </section>
);

export default Hero;
